import { render } from "./docSearch.vue?vue&type=template&id=049d3376&scoped=true"
import script from "./docSearch.vue?vue&type=script&lang=js"
export * from "./docSearch.vue?vue&type=script&lang=js"

import "./docSearch.vue?vue&type=style&index=0&id=049d3376&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049d3376"]])

export default __exports__